<template>
  <v-list-item inactive :ripple="false">
    <v-list-item-content>
      <template v-if="vertical">
        <div style="display: flex; flex-direction: row; gap: 8px;">
          <div class="checkbox-wrapper">
            <slot></slot>
          </div>
          <div style="display: flex; flex-direction: column; gap: 8px;">
            <v-list-item-title class="d-flex align-center">
              {{ title }}
              <HelpGuiasDialog v-if="helpText" :helpText="helpText" />
            </v-list-item-title>

            <v-list-item-subtitle v-if="subtitle" class="mb-2">
              {{ subtitle }}
            </v-list-item-subtitle>
          </div>
        </div>
      </template>
      <template v-else>
        <v-row align="center">
          <div style="display: flex; flex-direction: row; gap: 8px;">
            <v-col cols="12" sm="10" :md="titleWidth">
              <div style="display: flex; flex-direction: column; gap: 8px;">
                <v-list-item-title class="d-flex align-center">
                  {{ title }}
                  <HelpGuiasDialog v-if="helpText" :helpText="helpText" />
                </v-list-item-title>

                <v-list-item-subtitle v-if="subtitle">
                  {{ subtitle }}
                </v-list-item-subtitle>
              </div>
            </v-col>
            <v-col cols="12" sm="2" :md="contentWidth" :style="{ minWidth: minWidth }">
              <slot></slot>
            </v-col>
          </div>
        </v-row>
      </template>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import HelpGuiasDialog from './HelpGuiasDialog.vue'

export default {
  name: 'ConfigItem',

  components: {
    HelpGuiasDialog
  },

  props: {
    title: {
      type: String,
      required: true,
      default: ''
    },

    subtitle: {
      type: String,
      required: false,
      default: ''
    },

    helpText: {
      type: String,
      required: false,
      default: ''
    },

    vertical: {
      type: Boolean,
      default: false
    },

    titleWidth: {
      type: [String, Number],
      default: 3
    },

    contentWidth: {
      type: [String, Number],
      default: 1
    },

    minWidth: {
      type: String,
      default: '150px'
    }
  }
}
</script>

<style scoped>
:deep(.v-list-item__title),
:deep(.v-list-item__subtitle) {
  white-space: normal !important;
  word-break: break-word !important;
  overflow: visible !important;
  text-overflow: unset !important;
  display: block !important;
}

.checkbox-wrapper {
  margin-top: 8px;
  margin-left: 0;
}

.checkbox-wrapper :deep(.v-input--selection-controls) {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.mb-2 {
  margin-bottom: 8px !important;
}

.d-flex.align-center {
  display: flex;
  align-items: center !important;
  gap: 4px;
}

:deep(.v-list-item) {
  min-height: auto !important;
}

:deep(.v-list-item__content) {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}
</style>
